import React from "react";
import { CreateContainer } from "./ContainerCreate";
import { getThisDayPosts } from "../api/getThisDayPosts";

class ThisDayContainer extends React.Component {
  componentDidMount() {
    this.props.request(this.props.dateParam || null);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.dateParam !== this.props.dateParam) {
      this.props.request(this.props.dateParam || null);
    }
  }

  render = () => {
    const { data, loading, failure, render } = this.props;
    const result = (data && data.data) || {};
    const posts = (result && result.posts) || [];
    return render({ posts, loading, failure, month: result.month, day: result.day });
  };
}

ThisDayContainer.defaultProps = {
  dateParam: null,
};

export default CreateContainer(getThisDayPosts, ThisDayContainer);
